module.exports = __webpack_public_path__ + "img/iconfinder_logo_brand_brands_logos_affinity_designer_2993705.0b6ff5d9.png";